import { lazy } from "react";
// import { getCookie } from "cookies-next";

// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
// import PrivateRoute from "./PrivateRoute";
// import { CommonPrivFilter } from "utils/Privileges";
import EmployeeItemWiseReport from "views/reports/EmployeeItemWiseReport";
import WareHouseReport from "views/reports/WareHouseReport";

const WareHouseTransferReport = Loadable(
  lazy(() => import("views/reports/WareHouseTransferReport")),
);

// Lazy-loaded components
const DashboardDefault = Loadable(
  lazy(() => import("views/dashboard/Default")),
);
// import OrderList from "views/orderList";
const AddProduct = Loadable(lazy(() => import("views/Products/CreateProduct")));
const Master = Loadable(lazy(() => import("views/master/Master")));
const Payment = Loadable(lazy(() => import("views/Accounts/Payment")));
const Receipt = Loadable(lazy(() => import("views/Accounts/Receipt")));

const GstReports = Loadable(lazy(() => import("views/reports/GstReports")));
const VatReports = Loadable(lazy(() => import("views/reports/VatReports")));
const BatchWiseStock = Loadable(
  lazy(() => import("views/reports/BatchWiseStock")),
);
const SalesReport = Loadable(lazy(() => import("views/reports/SalesReport")));
const SalesReturnReport = Loadable(
  lazy(() => import("views/reports/SalesReturnReport")),
);
const PurchaseReport = Loadable(
  lazy(() => import("views/reports/PurchaseReport")),
);
const StockReport = Loadable(lazy(() => import("views/reports/StockReport")));
const BillWiseProfitReport = Loadable(
  lazy(() => import("views/reports/BillWiseProfitReport")),
);
const EmployeeWiseReport = Loadable(
  lazy(() => import("views/reports/EmployeeWiseReport")),
);
const CashFlowReport = Loadable(
  lazy(() => import("views/reports/CashFlowReport")),
);
const SubCategory = Loadable(lazy(() => import("views/others/SubCategory")));
const VoidBillEntry = Loadable(
  lazy(() => import("views/others/VoidBillEntry")),
);

const UserPrivilege = Loadable(
  lazy(() => import("views/others/UserPrivilege")),
);
const TaxUtilities = Loadable(lazy(() => import("views/others/TaxUtilities")));
const CurrencyRate = Loadable(lazy(() => import("views/others/CurrencyRate")));

const ThermalPrint = Loadable(
  lazy(() => import("views/PrintTypes/ThermalPrint")),
);
const A4Print = Loadable(lazy(() => import("views/PrintTypes/A4Print")));
const Error = Loadable(lazy(() => import("views/others/Error")));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  // element: (
  //   <PrivateRoute>
  //     <MainLayout />
  //   </PrivateRoute>
  // ),
  element: <MainLayout />,

  children: [
    { path: "/", element: <DashboardDefault /> },
    { path: "product", element: <AddProduct />, ref: "inventory-product" },
    { path: "master", element: <Master />, ref: "masters" },

    {
      path: "accounts",
      children: [
        {
          path: "payment",
          element: <Payment />,
          ref: "inventory-accounts-payment",
        },
        {
          path: "receipt",
          element: <Receipt />,
          ref: "inventory-accounts-receipt",
        },
      ],
    },

    {
      path: "reports",
      children: [
        { path: "gst", element: <GstReports /> },
        { path: "vat", element: <VatReports />, ref: "inventory-reports-vat" },
        {
          path: "SalesReport",
          element: <SalesReport />,
          ref: "inventory-reports-sales",
        },
        {
          path: "SalesReturnReport",
          element: <SalesReturnReport />,
          ref: "inventory-reports-salesreturn",
        },
        {
          path: "PurchaseReport",
          element: <PurchaseReport />,
          ref: "inventory-reports-purchase",
        },
        {
          path: "Stock",
          element: <StockReport />,
          ref: "inventory-reports-stock",
        },
        {
          path: "BatchWiseStock",
          element: <BatchWiseStock />,
          ref: "inventory-reports-batch-wise-stock",
        },
        {
          path: "BillWiseProfitReport",
          element: <BillWiseProfitReport />,
          ref: "inventory-reports-bill-wise-profit",
        },
        {
          path: "employeeitemwisesalesreport",
          element: <EmployeeItemWiseReport />,
          ref: "inventory-reports-employee-item-wise-sales-report",
        },
        {
          path: "EmployeeWiseReport",
          element: <EmployeeWiseReport />,
          ref: "inventory-reports-employeewise",
        },
        {
          path: "CashFlowReport",
          element: <CashFlowReport />,
          ref: "inventory-reports-cashflow",
        },
        {
          path: "warehouseReport",
          element: <WareHouseReport />,
          ref: "inventory-reports-cashflow",
        },
        {
          path: "warehouseTransferReport",
          element: <WareHouseTransferReport />,
          ref: "inventory-reports-warehouse",
        },
      ],
    },

    {
      path: "others",
      children: [
        {
          path: "createcategory",
          element: <SubCategory />,
          ref: "inventory-setup-category-sub",
        },
        {
          path: "voidbillentry",
          element: <VoidBillEntry />,
          ref: "inventory-setup-void-bill-entry",
        },
        { path: "userPrivilege", element: <UserPrivilege /> },
        {
          path: "taxUtilities",
          element: <TaxUtilities />,
          ref: "inventory-setup-tax-utilities",
        },
        {
          path: "CurrencyRate",
          element: <CurrencyRate />,
          ref: "inventory-setup-currency-rate",
        },

        { path: "thermalPrint", element: <ThermalPrint /> },
        { path: "a4", element: <A4Print /> },
      ],
    },
    { path: "*", element: <Error /> },
  ],
};

export default MainRoutes;
